import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';
import AnonymousOnlyRoute from '../modules/profile/components/AnonymousOnlyRoute';
import CreateCandidate from '../pages/profile/CreateCandidate';
import AccountCreationEmailAlert from '../pages/profile/AccountCreationEmailAlert';
import ProfileDetail from '../pages/profile/ProfileDetail';
import Settings from '../pages/profile/Settings';
import PrivateRoute from '../modules/profile/components/PrivateRoute';
import { Role } from '../models';
import CandidateProfileDetailPage from '../pages/profile/CandidateProfileDetailPage';
import AdminProfileDetail from '../pages/profile/AdminProfileDetail';
import CandidateProfileRequestForAmendment from '../pages/profile/ProfileRequestAmendment/CandidateProfileRequestForAmendment';
import UploadSupportingDocuments from '../pages/profile/ProfileRequestAmendment/UploadSupportingDocuments';

const { error: errorRoute } = RouteKey.child;
const {
  createCandidate,
  candidateDetail,
  coordinatorDetail,
  detail,
  emailAlert,
  settings,
  adminDetail,
  requestForAmendment,
  uploadSupportingDocuments,
} = RouteKey.profile.child;

const ProfileRoute = () => {
  const { path, url } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Redirect to={`${path}/${detail.route}`} />
      </Route>

      <AnonymousOnlyRoute path={`${path}/${createCandidate.route}`}>
        <CreateCandidate pathToEmailAlert={`${url}/${emailAlert.route}`} />
      </AnonymousOnlyRoute>

      <Route path={`${path}/${emailAlert.route}`}>
        <AccountCreationEmailAlert />
      </Route>

      {/* <PrivateRoute
        path={`${path}/${detail}`}
        roles={[Role.sysAdmin, Role.candidate, Role.coordinator]}
      >
        <CreateCandidate />
      </PrivateRoute> */}

      <PrivateRoute exact path={`${path}/${candidateDetail.route}`} roles={[Role.candidate]}>
        <CandidateProfileDetailPage />
      </PrivateRoute>

      <PrivateRoute
        path={`${path}/${candidateDetail.route}/:uuid/${uploadSupportingDocuments.route}`}
        roles={[Role.candidate]}
      >
        <UploadSupportingDocuments />
      </PrivateRoute>

      <PrivateRoute
        path={`${path}/${candidateDetail.route}/${requestForAmendment.route}`}
        roles={[Role.candidate]}
      >
        <CandidateProfileRequestForAmendment />
      </PrivateRoute>

      <PrivateRoute path={`${path}/${coordinatorDetail.route}`} roles={[Role.coordinator]}>
        <ProfileDetail />
      </PrivateRoute>

      <PrivateRoute path={`${path}/${adminDetail.route}`} roles={[Role.opsAdmin]}>
        <AdminProfileDetail />
      </PrivateRoute>

      <PrivateRoute
        path={`${path}/${settings.route}`}
        roles={[Role.candidate, Role.coordinator, Role.opsAdmin, Role.sysAdmin]}
      >
        <Settings />
      </PrivateRoute>

      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};

export default ProfileRoute;
